export default __webpack_public_path__ + "static/media/gameDealImage4.4723ca1b.png";